import { useGlobalTopBarSlots } from '@/providers/global-top-bar-provider';
import { useLayoutEffect, type ReactNode } from 'react';

function Start({ children }: { children: ReactNode }) {
    const { setStart } = useGlobalTopBarSlots();
    useLayoutEffect(() => {
        setStart(children);
        return () => setStart(null);
    }, [children, setStart]);
    return null;
}

function Breadcrumbs({ children }: { children: ReactNode }) {
    const { setBreadcrumbs } = useGlobalTopBarSlots();
    useLayoutEffect(() => {
        setBreadcrumbs(children);
        return () => setBreadcrumbs(null);
    }, [children, setBreadcrumbs]);
    return null;
}

function StartTrailing({ children }: { children: ReactNode }) {
    const { setStartTrailing } = useGlobalTopBarSlots();
    useLayoutEffect(() => {
        setStartTrailing(children);
        return () => setStartTrailing(null);
    }, [children, setStartTrailing]);
    return null;
}

function Center({ children }: { children: ReactNode }) {
    const { setCenter } = useGlobalTopBarSlots();
    useLayoutEffect(() => {
        setCenter(children);
        return () => setCenter(null);
    }, [children, setCenter]);
    return null;
}

function Actions({ children }: { children: ReactNode }) {
    const { setActions } = useGlobalTopBarSlots();
    useLayoutEffect(() => {
        setActions(children);
        return () => setActions(null);
    }, [children, setActions]);
    return null;
}

function Edge({ className }: { className: string }) {
    const { setEdgeClassName } = useGlobalTopBarSlots();
    useLayoutEffect(() => {
        setEdgeClassName(className);
        return () => setEdgeClassName(null);
    }, [className, setEdgeClassName]);
    return null;
}

export const GlobalTopBar = {
    Start,
    Breadcrumbs,
    StartTrailing,
    Center,
    Actions,
    Edge,
};
